import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var r = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-320 -276)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "black"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.478 8.98554H10.8693C10.8693 8.5053 10.48 8.11597 9.99977 8.11597C9.51953 8.11597 9.1302 8.5053 9.1302 8.98554H6.52148C6.52148 9.46581 6.9398 9.85511 7.42004 9.85511H7.39105C7.39105 10.3354 7.78035 10.7247 8.26063 10.7247C8.26063 11.205 8.64992 11.5942 9.1302 11.5942H10.8693C11.3496 11.5942 11.7389 11.205 11.7389 10.7247C12.2192 10.7247 12.6085 10.3354 12.6085 9.85511H12.5795C13.0598 9.85511 13.478 9.46581 13.478 8.98554Z",
      fill: "#FF9811"
    })
  ]
});
export {
  r as default
};
